module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-9-zoom.a2051642.png";